import { ToolImplementation, ToolResult, ToolSchema } from '../tool-types';

export const flipCourseCardToolMetroSchema: ToolSchema = {
  type: 'function',
  name: 'flip_course_card',
  description: 'Flip a course card to show its description on screen. Call this when the user asks for more details about a specific course.',
  parameters: {
    type: 'object',
    properties: {
      courseId: {
        type: 'string',
        description: 'The courseId of the course card to flip (from the search results)'
      }
    },
    required: ['courseId'],
    additionalProperties: false
  }
};

export const flipCourseCardToolMetroImplementation: ToolImplementation = async (
  args: any
): Promise<ToolResult> => {
  try {
    const courseId = typeof args?.courseId === 'string' ? args.courseId.trim() : '';

    if (!courseId) {
      return { success: false, error: 'courseId is required.' };
    }

    if (typeof window !== 'undefined') {
      window.dispatchEvent(
        new CustomEvent('metro-flip-course', {
          detail: { courseId }
        })
      );
    }

    return {
      success: true,
      data: { courseId, status: 'flipped' }
    };
  } catch (error) {
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Unknown error while flipping course card'
    };
  }
};
